import axios from "./index";

class AcreedoresApi {
  static fetchAcreedoresPaginacion = (params = {}) => {
    const { page = 1, page_size = 25, search = "", es_recurrente = "" } = params;
    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("page_size", page_size.toString());
    if (search.trim()) {
      queryParams.append("search", search.trim());
    }
    if (es_recurrente !== "") {
      queryParams.append("es_recurrente", es_recurrente.toString());
    }
    return axios.get(`/procesos/acreedores/paginacion/?${queryParams.toString()}`);
  };

  static fetchAcreedoresStats = () => {
    return axios.get("/procesos/acreedores/stats/");
  };

  static searchAcreedores = (searchTerm, otherParams = {}) => {
    return this.fetchAcreedoresPaginacion({
      search: searchTerm,
      page: 1, // Reset to first page on search
      ...otherParams,
    });
  };

  static getAcreedoresPage = (page, currentParams = {}) => {
    return this.fetchAcreedoresPaginacion({
      ...currentParams,
      page,
    });
  };

  static getAcreedoresWithFilters = (filters) => {
    return this.fetchAcreedoresPaginacion({
      page: 1, // Reset to first page when changing filters
      ...filters,
    });
  };

  static fetchAcreedores = () => {
    return axios.get(`/procesos/acreedores/`);
  };

  static fetchAcreedoresSoft = () => {
    return axios.get(`/procesos/acreedores/soft`);
  };

  static fetchAcreedorByIdentificacion = (identificacion) => {
    return axios.get(`/procesos/acreedores/${identificacion}/consultar/`);
  };

  static createAcreedor = (data) => {
    return axios.post(`/procesos/acreedores/crear/`, data);
  };

  static updateAcreedor = (id, data) => {
    return axios.put(`/procesos/acreedores/${id}/`, data);
  };

  static deleteAcreedor = (id) => {
    return axios.delete(`/procesos/acreedores/${id}/eliminar/`);
  };
}
export default AcreedoresApi;
